import { useQueryClient } from "@tanstack/react-query"
import { updateFilters } from "../../api/filters"
import { IFilters } from "../../utils"


export const useUpdateFilters = () => {
    const queryClient = useQueryClient()

    return async (filters: IFilters) => { 
        await updateFilters(filters) 
        await queryClient.invalidateQueries({ queryKey: ['filters'] })
    }
}